import { ModelStore } from './model.store';
import { InstagramStore } from './instagram.store';

export const stores = {
  modelStore: new ModelStore(),
  instagramStore: new InstagramStore()
};
